<template>
  <div class="display-flex" style="align-items:center;height:300px;">
    <template v-if="mode === 'copy'">
      <div class="display-flex" style="align-items:center;justify-content:center;">
        <div class="com-anm22-app-text-xl">
          {{ $anm22.strLang(lang, 'Select project to copy', 'Selezionare il progetto da copiare') }}
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <!-- <template v-if="error">
          <div class="com-anm22-app-text-l" style="color:red;">
            {{ $anm22.strLang(lang, 'No project selected', 'Nessun progetto selezionato') }}
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
        </template> -->
        <div class="wg-row">
          <div class="wg-col wg-xs-12 wg-sm-6">
            <wg-search
                :placeholder="$anm22.strLang(lang, 'Search...', 'Cerca...')"
                :mode="'offline'"
                :searchFn="searchProjects"
                :clickFn="selectProjectToCopy"
                :debounceTime="0"
            ></wg-search>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-6">
            <select class="com-anm22-app-select" v-model="projectToCopy">
              <option value="" selected disabled hidden>{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
              <option 
                  v-for="(project, index) in projects.sort((a,b) => b.startDate - a.startDate)" 
                  :key="'proj-'+index" 
                  :value="project.idWorldProject">
                {{ project.projectId + ((project.projectId !== '' && project.name !== '') ? ' - ' : '') + project.name }}
              </option>
            </select>
          </div>
        </div>
        <!-- <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <label for="condCheckbox" class="com-anm22-app-text-l" style="cursor:pointer;">
            {{ $anm22.strLang(lang, 'Copy economic conditions', 'Copia condizioni economiche') }}
          </label>
          <div class="com-anm22-app-horizontal-space" style="height:20px;"></div>
          <input 
            id="condCheckbox"
            type="checkbox" 
            style="cursor:pointer;"
            v-model="copyConditions">
        </div> -->
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <input 
              type="button" 
              :value="$anm22.strLang(lang, 'Back', 'Indietro')" 
              @click="back">
          <div class="com-anm22-horizontal-space" style="width:20px;"></div>
          <input 
            v-if="projectToCopy"
            type="button"
            class="com-anm22-button-blue"
            :value="$anm22.strLang(lang, 'Next', 'Procedi')"
            @click="copyProject" >
        </div>
      </div>
    </template>
    <!-- NUOVO PROGETTO SCELTA DA ZERO O CON TEMPLATE -->
    <template v-else-if="mode === 'new'">
      <div class="wg-row" style="align-items:center;justify-content:center;">
        <input 
            id="scratch"
            type="radio"
            value="scratch"
            v-model="newProjectMode">
        <div class="com-anm22-app-text-l" style="margin:0 5px;">
          {{ $anm22.strLang(lang, 'Empty project', 'Progetto vuoto') }}
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <input 
            id="template"
            type="radio"
            value="template"
            v-model="newProjectMode">
        <div class="com-anm22-app-text-l" style="margin:0 5px;">
          {{ $anm22.strLang(lang, 'From template', 'Da template') }}
        </div>
        <div class="vertical-height-div" style="height:10px;"></div>
        <template v-if="error">
          <div class="com-anm22-app-text-l" style="color:red;">
            {{ $anm22.strLang(lang, 'No project selected', 'Nessun progetto selezionato') }}
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
        </template>
        <select v-if="newProjectMode === 'template'" class="com-anm22-app-select" @change="error = false" v-model="projectTemplate">
          <option value="" selected disabled hidden>{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
          <option 
              v-for="(project, index) in projectTemplates" 
              :key="'proj-t-'+index" 
              :value="project.idWorldProject">
            {{ (project.projectId !== '' ? project.projectId + '-' : '') + project.name }}
          </option>
        </select>
        <!-- <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <label for="condCheckbox" class="com-anm22-app-text-l" style="cursor:pointer;">
            {{ $anm22.strLang(lang, 'Copy economic conditions', 'Copia condizioni economiche') }}
          </label>
          <div class="com-anm22-app-horizontal-space" style="height:20px;"></div>
          <input 
            id="condCheckbox"
            type="checkbox" 
            style="cursor:pointer;"
            v-model="copyConditions">
        </div> -->
        <div class="vertical-height-div" style="height:20px;"></div>
        <div class="wg-row" style="align-items:center;justify-content:center;">
          <input 
              type="button" 
              :value="$anm22.strLang(lang, 'Back', 'Indietro')" 
              @click="mode = ''">
          <div class="com-anm22-horizontal-space" style="width:20px;"></div>
          <input 
            v-if="newProjectMode === 'scratch' || projectTemplate"
            type="button"
            class="com-anm22-button-blue"
            :value="$anm22.strLang(lang, 'Next', 'Procedi')"
            @click="newProjectMode === 'scratch' ? newProject() : copyProject()" >
        </div>
      </div>
    </template>
    <template v-else>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="tk-new-project-box left">
            <img 
                :src="$anm22.icons.getTasksIcon('unselectedBlack')"
                class="img">
            <div class="mode-title">
              {{ $anm22.strLang(lang, 'New project', 'Nuovo progetto') }}
            </div>
            <div class="mode-subtitle">
              {{ $anm22.strLang(lang, 'Create new project', 'Crea nuovo progetto') }}
            </div>
            <div class="mode-btn" style="cursor:pointer;" @click="newProjectSelect">
              {{ $anm22.strLang(lang, 'CREATE', 'CREA') }}
            </div>
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="tk-new-project-box">
              <img 
                  :src="$anm22.icons.getTasksIcon('copyBlack')"
                  class="img">
              <div class="mode-title">
                {{ $anm22.strLang(lang, 'Copy project', 'Copia progetto') }}
              </div>
              <div class="mode-subtitle">
                {{ $anm22.strLang(lang, 'Copy an existing project', 'Copia un progetto esistente') }}
              </div>
              <div class="mode-btn" style="cursor:pointer;" @click="mode = 'copy'">
                {{ $anm22.strLang(lang, 'COPY', 'COPIA') }}
              </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    work: [String, Number],
    customerId:[String,Number]
  },
  data() {
    return {
      mode: '',
      /* Copia progetto */
      projectToCopy: '',
      copyConditions: false,
      /* Nuovo progetto */
      newProjectMode: 'scratch',
      projectTemplate: '',
      error: false
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    projects() {
      if(this.work === 'my') {
        return this.$store.getters['projects/getAll'].filter(p => !p.template && !p.deleted);
      } else {
        return this.$store.getters['projects/getAllByWork'](this.work).filter(p => !p.template && !p.deleted);
      }
    },
    projectTemplates() {
      if(this.work === 'my') {
        return this.$store.getters['projects/getAll'].filter(p => p.template && !p.deleted);
      } else {
        return this.$store.getters['projects/getAllByWork'](this.work).filter(p => p.template && !p.deleted);
      }
    }
  },
  methods: {
    /* Copy project functions */
    searchProjects(string) {
      const regexp = new RegExp(string, 'i');
      return this.projects
        .filter(p => {
          const fullname = (p.projectId !== '' ? p.projectId + '-' : '') + p.name;
          return -1 !== fullname.search(regexp);
        })
        .map(p => {
          const label = (p.projectId || "")
              + (p.projectId && p.name ? " - " : "")
              + (p.name || "");
          return {
            label: label,
            id: p.idWorldProject
          }
        });
    },
    selectProjectToCopy(id) {
      this.projectToCopy = id;
    },
    back() {
      this.mode = '';
      this.projectToCopy = '';
    },
    /* -- */
    newProjectSelect() {
      if(this.projectTemplates.length > 0) {
        this.mode = 'new';
      } else {
        this.newProject();
      }
    },
    /* Start creating new project */
    newProject() {
      this.$router.push({ name: 'newProject', params: { work: this.work ,customerId: this.customerId ? this.customerId : null} });
    },
    copyProject() {
      let params = {};
      if(this.mode === 'new') {
        if(this.projectTemplate === '') {
          this.error = true;
          return;
        }
        params = {
          work: this.work, 
          projectToCopy: this.projectTemplate, 
          copyConditions: this.copyConditions
        }
        if(this.customerId != null) {
          params.customerId = this.customerId;
        }
      } else {
        if(this.projectToCopy === '') {
          this.error = true;
          return;
        }
        params = {
          work: this.work, 
          projectToCopy: this.projectToCopy, 
          copyConditions: this.copyConditions
        }
        if(this.customerId != null) {
          params.customerId = this.customerId;
        }
      }
      this.$router.push({ name:'copyProject', params });
    }
  }
}
</script>

<style lang="scss" scoped>
.label-input-radio {
  display: block;
  height: 20px;
  width: 20px;
  border: 1px solid #bbb;
  border-radius: 50%;
  font-size: 18px;
  padding: 0px 3px;
  cursor: pointer;
}
.tk-new-project-box {
  width: 100%;
  &.left {
    border-right:1px solid #ccc;
  }
}
@media screen and (max-width: 768px){
  .tk-new-project-box.left {
    border: none;
  }
}
</style>
